import { io } from 'socket.io-client';
import Cookies from 'js-cookie';
import { SOCKET_URL } from '../config';

class AdminSocketService {
    socket = null;
    connect() {
        const getAdminId = () => {
            const c = Cookies?.default || Cookies;
            return c?.get?.('adminId') || localStorage.getItem('adminId');
        };

        if (!this.socket) {
            console.log(`[AdminSocketService] Connecting to signaling server at: ${SOCKET_URL}`);
            this.socket = io(SOCKET_URL);
            this.socket.on('connect', () => {
                console.log('[AdminSocketService] Admin connected to signaling server:', this.socket.id);
                const adminId = getAdminId();
                if (adminId) {
                    console.log(`[AdminSocketService] Emitting admin-subscribe for adminId: ${adminId}`);
                    this.socket?.emit('admin-subscribe', { adminId });
                } else {
                    console.error("[AdminSocketService] No adminId found. Please log in.");
                }
            });
        } else if (this.socket.connected) {
            const adminId = getAdminId();
            if (adminId) {
                this.socket.emit('admin-subscribe', { adminId });
            }
        }
        return this.socket;
    }
}

const adminSocketService = new AdminSocketService();
export default adminSocketService;
